// extracted by mini-css-extract-plugin
module.exports = {"SectionA6":"SectionA6_SectionA6__1sTLs"};